import React, { Component } from 'react'
import moment from 'moment'
import PropTypes from 'prop-types'
import { Button, Table, Modal } from 'react-bootstrap'
import { connectModal } from 'redux-modal'
import { get_events_by_lowering, get_lowerings_by_cruise } from '../api'
import { _Lowering_, _Lowerings_, _lowering_ } from '../vocab'

let fileDownload = require('js-file-download')

class StatsModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      lowerings: null,
      lowering_stats: null,
      lowering_samples: null,
      lowering_stat_totals: null,
      status_msg: ''
    }

    this.handleClose = this.handleClose.bind(this)
    this.buildStatsAndTotals = this.buildStatsAndTotals.bind(this)
    this.exportDataToFile = this.exportDataToFile.bind(this)
  }

  componentDidMount() {
    this.fetchLowerings()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.cruise && this.props.cruise !== prevProps.cruise) {
      this.fetchLowerings()
    }

    if (this.state.lowerings && this.state.lowerings != prevState.lowerings) {
      this.fetchLoweringSampleCount()
    }

    if (this.state.lowering_samples && this.state.lowering_samples != prevState.lowering_samples) {
      this.buildStatsAndTotals()
    }
  }

  async fetchLoweringSampleCount() {
    this.setState({ status_msg: 'Downloading sample counts...' })
    const samples = await this.state.lowerings.map(async (lowering) => {
      const samples_count = await get_events_by_lowering({ value: 'SAMPLE' }, lowering.id)
        .then((response) => {
          const sample_events = response.filter((event) => event['event_value'] === 'SAMPLE')
          return sample_events.length
        })
        .catch((error) => {
          console.error(error)
          return 0
        })
      return samples_count
    })

    Promise.all(samples).then((values) => {
      this.setState({ lowering_samples: values, status_msg: '' })
    })
  }

  async fetchLowerings() {
    this.setState({ status_msg: `Downloading ${_lowering_} data...` })

    const lowerings = await get_lowerings_by_cruise(this.props.cruise.id)

    lowerings.reverse()

    this.setState({ lowerings, status_msg: '' })
  }

  buildStatsAndTotals() {
    const lowering_stats = this.state.lowerings.map((lowering, index) => {
      const stats = {
        start_dt: null,
        descending_dt: null,
        on_bottom_dt: null,
        off_bottom_dt: null,
        on_surface_dt: null,
        stop_dt: null,
        max_depth: 0,
        total_duration: null,
        on_bottom_duration: null,
        samples_collected: 0,
        pilot: '',
        surface_officer: '',
        passengers: []
      }

      if (lowering.start_ts) {
        try {
          stats.start_dt = moment.utc(lowering.start_ts)
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.stop_ts) {
        try {
          stats.stop_dt = moment.utc(lowering.stop_ts)
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta.milestones && lowering.lowering_additional_meta.milestones.lowering_start) {
        try {
          stats.start_dt = moment.utc(lowering.lowering_additional_meta.milestones.lowering_start)
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta.milestones && lowering.lowering_additional_meta.milestones.lowering_descending) {
        try {
          stats.descending_dt = moment.utc(lowering.lowering_additional_meta.milestones.lowering_descending)
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta.milestones && lowering.lowering_additional_meta.milestones.lowering_on_bottom) {
        try {
          stats.on_bottom_dt = moment.utc(lowering.lowering_additional_meta.milestones.lowering_on_bottom)
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta.milestones && lowering.lowering_additional_meta.milestones.lowering_off_bottom) {
        try {
          stats.off_bottom_dt = moment.utc(lowering.lowering_additional_meta.milestones.lowering_off_bottom)
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta.milestones && lowering.lowering_additional_meta.milestones.lowering_on_surface) {
        try {
          stats.on_surface_dt = moment.utc(lowering.lowering_additional_meta.milestones.lowering_on_surface)
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta.stats && lowering.lowering_additional_meta.stats.max_depth) {
        try {
          stats.max_depth = parseFloat(lowering.lowering_additional_meta.stats.max_depth)
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta.stats && lowering.lowering_additional_meta.stats.bounding_box) {
        try {
          stats.bounding_box = lowering.lowering_additional_meta.stats.bounding_box.map((coord) => parseFloat(coord))
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta && lowering.lowering_additional_meta.pilot) {
        try {
          stats.pilot = lowering.lowering_additional_meta.pilot
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta && lowering.lowering_additional_meta.surface_officer) {
        try {
          stats.surface_officer = lowering.lowering_additional_meta.surface_officer
        } catch (err) {
          console.error(err)
        }
      }

      if (lowering.lowering_additional_meta && lowering.lowering_additional_meta.passengers) {
        try {
          stats.passengers = lowering.lowering_additional_meta.passengers
        } catch (err) {
          console.error(err)
        }
      }

      // total_duration
      if (stats.start_dt && stats.stop_dt) {
        stats.total_duration = stats.stop_dt - stats.start_dt
      }

      // deployment_duration
      if (stats.start_dt && stats.descending_dt) {
        stats.deployment_duration = stats.descending_dt - stats.start_dt
      }

      // descent_duration
      if (stats.descending_dt && stats.on_bottom_dt) {
        stats.descent_duration = stats.on_bottom_dt - stats.descending_dt
      }

      // on_bottom_duration
      if (stats.on_bottom_dt && stats.off_bottom_dt) {
        stats.on_bottom_duration = stats.off_bottom_dt - stats.on_bottom_dt
      }

      // ascent_duration
      if (stats.off_bottom_dt && stats.on_surface_dt) {
        stats.ascent_duration = stats.on_surface_dt - stats.off_bottom_dt
      }

      // recovery_duration
      if (stats.on_surface_dt && stats.stop_dt) {
        stats.recovery_duration = stats.stop_dt - stats.on_surface_dt
      }

      // samples
      stats.samples_collected = this.state.lowering_samples[index] ? this.state.lowering_samples[index] : 0

      return stats
    })

    this.setState({ lowering_stats })
  }

  exportDataToFile() {
    var Results = []

    Results.push([`${_Lowering_} ID`, 'Location', 'Pilot', 'Surface Officer', 'Passengers', 'Deck to Deck', 'Samples', 'Max Depth'])

    this.state.lowering_stats.forEach((stat, index) => {
      Results.push([
        this.state.lowerings[index].lowering_id,
        '"' + this.state.lowerings[index].lowering_location + '"',
        '"' + stat.pilot + '"',
        '"' + stat.surface_officer + '"',
        '"' + stat.passengers.join(', ') + '"',
        moment.duration(stat.total_duration).format('HH:mm:ss', { trim: false }),
        stat.samples_collected,
        stat.max_depth
      ])
    })

    const lowering_stat_totals = this.state.lowering_stats.reduce(
      (totals, lowering) => {
        totals.total_duration += lowering.total_duration
        totals.samples_collected += lowering.samples_collected
        totals.max_depth = totals.max_depth >= lowering.max_depth ? totals.max_depth : lowering.max_depth

        return totals
      },
      {
        total_duration: 0,
        deployment_duration: 0,
        samples_collected: 0,
        max_depth: 0
      }
    )

    Results.push([
      `${this.state.lowerings.length} ${_Lowerings_}`,
      null,
      null,
      null,
      'Totals:',
      moment.duration(lowering_stat_totals.total_duration).format('HH:mm:ss', { trim: false }),
      lowering_stat_totals.samples_collected,
      lowering_stat_totals.max_depth
    ])

    let CsvString = ''

    Results.forEach(function (RowItem) {
      CsvString += RowItem.join(',') + '\r\n'
    })

    fileDownload(CsvString, `${this.props.cruise.cruise_id}_cruise_data_summary.csv`)
  }

  handleClose() {
    this.props.handleHide()
  }

  renderStatsTable(stats) {
    if (stats == null) {
      return null
    }

    const statTableHeaders = (
      <thead>
        <tr>
          <th>{_Lowering_} ID</th>
          <th>Location</th>
          <th>Pilot</th>
          <th>Surface Officer</th>
          <th>Passengers</th>
          <th>Deck to Deck</th>
          <th>Samples</th>
          <th>Max Depth</th>
        </tr>
      </thead>
    )

    const statsTableData = stats.map((stat, index) => {
      return (
        <tr key={`lowering_${this.state.lowerings[index].lowering_id}`}>
          <td>{this.state.lowerings[index].lowering_id}</td>
          <td>{this.state.lowerings[index].lowering_location}</td>
          <td>{stat.pilot}</td>
          <td>{stat.surface_officer}</td>
          <td>{stat.passengers.join(', ')}</td>
          <td>{`${moment.duration(stat.total_duration).format('HH:mm:ss', { trim: false })}`}</td>
          <td>{stat.samples_collected}</td>
          <td>{stat.max_depth}</td>
        </tr>
      )
    })

    const lowering_stat_totals = stats.reduce(
      (totals, lowering) => {
        totals.total_duration += lowering.total_duration
        totals.samples_collected += lowering.samples_collected
        totals.max_depth = totals.max_depth >= lowering.max_depth ? totals.max_depth : lowering.max_depth

        return totals
      },
      {
        total_duration: 0,
        samples_collected: 0,
        max_depth: 0
      }
    )

    const statTableDataTotals = (
      <tr key='stat_totals'>
        <th>{`${this.state.lowerings.length} ${_Lowerings_}`}</th>
        <th></th>
        <th></th>
        <th></th>
        <th>Totals:</th>
        <th>{`${moment.duration(lowering_stat_totals.total_duration).format('HH:mm:ss', { trim: false })}`}</th>
        <th>{lowering_stat_totals.samples_collected}</th>
        <th>{lowering_stat_totals.max_depth}</th>
      </tr>
    )

    return (
      <Table striped bordered hover responsive size='sm' style={{ fontSize: '.8rem' }}>
        {statTableHeaders}
        <tbody>
          {statsTableData}
          {statTableDataTotals}
        </tbody>
      </Table>
    )
  }

  render() {
    const { show, handleHide, cruise } = this.props

    const statsTable = this.renderStatsTable(this.state.lowering_stats)

    if (cruise) {
      return (
        <Modal size='lg' show={show} onHide={handleHide}>
          <Modal.Header closeButton>
            <Modal.Title as='h5'>Stats for Sub Team</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {statsTable}
            <span className='text-warning'>{this.state.status_msg}</span>
            <span className='float-right'>
              <Button variant='outline-primary' size='sm' onClick={this.exportDataToFile}>
                Export
              </Button>
            </span>
          </Modal.Body>
        </Modal>
      )
    } else {
      return null
    }
  }
}

StatsModal.propTypes = {
  cruise: PropTypes.object,
  handleHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired
}

export default connectModal({ name: 'statsForSubTeam' })(StatsModal)
